module.exports = __webpack_public_path__ + "img/IMG_1645_L_Black_MockedUp.c2b6c018.jpg";